var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBorderEditPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    transform: "matrix(-1 0 0 1 24 0)",
    fill: "#E9E9EC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1425 4.5H8.8575C6.1275 4.5 4.5 6.1275 4.5 8.8575V15.135C4.5 17.8725 6.1275 19.5 8.8575 19.5H15.135C17.865 19.5 19.4925 17.8725 19.4925 15.1425V8.8575C19.5 6.1275 17.8725 4.5 15.1425 4.5ZM11.2125 16.1325C10.995 16.35 10.5825 16.56 10.2825 16.605L8.4375 16.8675C8.37 16.875 8.3025 16.8825 8.235 16.8825C7.9275 16.8825 7.6425 16.7775 7.44 16.575C7.1925 16.3275 7.0875 15.9675 7.1475 15.57L7.41 13.725C7.455 13.4175 7.6575 13.0125 7.8825 12.795L11.2275 9.45C11.2875 9.6075 11.3475 9.765 11.43 9.945C11.505 10.1025 11.5875 10.2675 11.6775 10.4175C11.7525 10.545 11.835 10.665 11.9025 10.755C11.985 10.8825 12.0825 11.0025 12.1425 11.07C12.18 11.1225 12.21 11.16 12.225 11.175C12.4125 11.4 12.63 11.61 12.8175 11.7675C12.87 11.82 12.9 11.85 12.915 11.8575C13.0275 11.9475 13.14 12.0375 13.2375 12.105C13.3575 12.195 13.4775 12.2775 13.605 12.345C13.755 12.435 13.92 12.5175 14.085 12.6C14.2575 12.675 14.415 12.7425 14.5725 12.795L11.2125 16.1325ZM16.0275 11.3175L15.3375 12.015C15.2925 12.06 15.2325 12.0825 15.1725 12.0825C15.15 12.0825 15.12 12.0825 15.105 12.075C13.5825 11.64 12.3675 10.425 11.9325 8.9025C11.91 8.82 11.9325 8.73 11.9925 8.6775L12.69 7.98C13.83 6.84 14.9175 6.8625 16.035 7.98C16.605 8.55 16.8825 9.0975 16.8825 9.6675C16.875 10.2075 16.5975 10.7475 16.0275 11.3175Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorderEditPencil);
export default __webpack_public_path__ + "static/media/border-edit-pencil.9010a6984096939503d4d3c704300d0b.svg";
export { ForwardRef as ReactComponent };